import { loader } from 'graphql.macro'

export default function editTicketPage ({ dataLoaders, queryKey }) {
  const [, variables] = queryKey
  const schema = loader('./editTicketPage.graphql')
  return dataLoaders.dispatcher.graphQLClient.request(schema, {
    haulerId: variables.haulerId,
    ticketId: variables.ticketId
  })
}
